import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TableUtils from '../../../../../utils/TableUtils';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import Session from "../../../../../utils/Session";
import CaptchaModal from "../../../../../utils/CaptchaModal";

class ResultadoBusqueda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        datos: this.procesarDatos(props.datos),
        times: Session.getAccessTimes()
    };

    this.checker = null;
    this.setCheckerRef = element => {
        this.checker = element;
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      datos: this.procesarDatos(nextProps.datos)
    });
  }

  procesarDatos(datos) {
    return datos;
  }

  onRowClick = (row) => {
    /*  this.checker.setTarget(row);
      if (!this.checkMaxTimes()) {
          return;
      }

      this.setState({
          times: Session.incAccessTimes()
      });*/
    this.props.onResultadoSeleccionado(row.cuil,row.tipoTitular === 'Persona');
  }

    goToDetail = () => {
        if (!this.checker.getTarget()) {
            return;
        }
        this.setState({
            times: Session.incAccessTimes()
        });

        let cuil = this.checker.getTarget().cuil;
        let tipoTitular = this.checker.getTarget().tipoTitular;

        this.props.onResultadoSeleccionado(cuil, tipoTitular === 'Persona');
    };

    closeModal = () => {
        this.checker.closeModal();
    };

    checkMaxTimes = () => {
        return this.state.times < 50;
    };

  render() {
    const table_options = TableUtils.defaultConfig({ pagination: true },
      {
        onRowClick: this.onRowClick,
        onPageChange: this.props.onPageChange,
        page: this.props.currentPage,
        sizePerPage: 20
      });

    return (
        <div>
            <BootstrapTable data={this.state.datos} remote={true} options={table_options}
                            fetchInfo={{ dataTotalSize: this.props.totalDataSize }}
                            striped={true} pagination>
                <TableHeaderColumn width="350px" dataField="nombre" dataSort={true}>Nombre</TableHeaderColumn>
                <TableHeaderColumn width="150px" dataField="cuil" isKey={true} dataSort={true}>CUIL/CUIT</TableHeaderColumn>
            </BootstrapTable>
        </div>

    );
  }

  static propTypes = {
    datos: PropTypes.array,
    onResultadoSeleccionado: PropTypes.func,
    onPageChange: PropTypes.func,
    currentPage: PropTypes.number,
    totalDataSize: PropTypes.number
  }
}


export default ResultadoBusqueda;



// WEBPACK FOOTER //
// ./src/scenes/telefonos/components/telefonos-busqueda/components/ResultadoBusqueda.js